import script from "./batch-replace.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-replace.vue?vue&type=script&setup=true&lang=js"

import "./batch-replace.vue?vue&type=style&index=0&id=a9b81384&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b81384"]])

export default __exports__